var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group mb-4" }, [
    _c("label", { attrs: { for: _vm.name } }, [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _c("textarea", {
      staticClass: "form-control",
      class: { "is-invalid": _vm.error !== "" },
      attrs: { id: _vm.name, name: _vm.name, rows: _vm.rows },
      domProps: { value: _vm.value },
      on: {
        input: function($event) {
          return _vm.updateValue($event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _vm.count && _vm.value
      ? _c(
          "small",
          {
            staticClass: "input-count",
            class: { "input-count-error": _vm.value.length > _vm.max }
          },
          [_vm._v(_vm._s(_vm.value.length) + "/" + _vm._s(_vm.max))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.error !== ""
      ? _c("div", { staticClass: "invalid-feedback" }, [
          _vm._v("\n    " + _vm._s(_vm.error) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/fields/TextField.vue?vue&type=template&id=e7e9862a&
// module id = 373
// module chunks = 0